import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useParams } from "react-router-dom";
import { Paper } from "@material-ui/core";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import CardIcon from "@material-ui/icons/CreditCard";
import HistoryIcon from "@material-ui/icons/HistoryOutlined";
import WalletIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import InvoicesTable from "../components/InvoicesTable";

import SideBar from "../components/SideBar";

import { Context as PortalContext } from "../context/portal.context.js";
import { Context as AuthContext } from "../context/auth.context.js";

const qs = require("qs");

export default function EnhancedTable(props) {
  const authState = React.useContext(AuthContext);
  const portalState = React.useContext(PortalContext);
  let { op } = useParams();

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });


  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        boxSizing: "border-box",
        flexDirection: isTabletOrMobile ? "column" : "row",
      }}
    >
      {portalState.state.showSummarySidebar ? (
        <SideBar theme={props.theme} />
      ) : null}

      <div
        className="invoices-wrapper"
        style={{
          width: "100%",
          boxSizing: "border-box",
          paddingTop: isTabletOrMobile ? 0 : 25,
          paddingLeft: isTabletOrMobile ? 15 : 0,
          paddingRight: isTabletOrMobile ? 15 : 0,
        }}
      >
        <InvoicesTable theme={props.theme} />
      </div>
    </div>
  );
}
